import { AfterViewInit, Component, forwardRef, HostBinding, Injector, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectButtonModule, SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { ControlValueAccessor, FormControl, FormsModule, NgControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectItem } from 'primeng/api';
import { Color } from '../../enums/utils/colors';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export interface ISelectButtonColoredItem {
  value: any;
  label?: string;
  icon?: string;
  color?: Color | string;
  tooltip?: string;
};

@Component({
  selector: 'app-select-button-colored',
  standalone: true,
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule,
    SelectButtonModule, TranslateModule,
    NgbTooltipModule
  ],
  templateUrl: './select-button-colored.component.html',
  styleUrls: ['./select-button-colored.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectButtonColoredComponent),
    multi: true
  }],

})
export class SelectButtonColoredComponent implements OnInit, ControlValueAccessor, AfterViewInit {

  @Input() options: ISelectButtonColoredItem[] = [];
  @Input() nullValueTooltip: string | null = null;

  value: any;
  control: FormControl<any> | undefined;
  disabled: boolean = false;

  @HostBinding('class') uniqueClass: string = this.makeid();

  constructor(
    private injector: Injector,
    private translate: TranslateService
  ) { }

  onChange: ((value: any) => void) | undefined;
  onTouched: (() => void) | undefined;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const ngControl: NgControl | null = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as FormControl<any>;
    }
  }

  handleOptionColors() {
    setTimeout(() => {
      (document.querySelectorAll(`.${this.uniqueClass} .p-selectbutton > .p-button`) as unknown as NodeListOf<HTMLElement>).forEach((opt, i) => {
        const color = this.options[i].color;
        if (!color) return;
        if (opt.classList.contains('p-highlight')) {
          opt.style.background = `var(${color})`;
          opt.style.borderColor = `var(${color})`;
        } else {
          opt.style.removeProperty('background');
          opt.style.removeProperty('border-color');
        }
      });
    })
  }

  onOptionClick(e: SelectButtonOptionClickEvent) {
    if (this.onChange) {
      const val = e.option.value;
      let valToSet = null;
      if (this.control?.value === val) {
        valToSet = null;
      }
      else {
        valToSet = val;
      }
      this.onChange(valToSet);
      this.value = valToSet;
      this.handleOptionColors();
    }
  }

  getItemTooltip(item: ISelectButtonColoredItem) {
    return this.value === null ? null : (item.tooltip ? this.translate.instant(item.tooltip) : null);
  }
  getBoxTooltip() {
    return this.value === null ? this.nullValueTooltip : null;
  }


  writeValue(obj: any): void {
    this.value = obj;
    this.handleOptionColors();
  }
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  makeid() {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var charactersLength = characters.length;
    for ( var i = 0; i < 10; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
